import { FileCheck } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import EmptyTable from '@/components/table/components/EmptyTable.tsx';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { useConfirmationDialogContext } from '@/components/ui/ConfirmDialog.Context.tsx';
import acceptedConsentsApi from '@/features/dashboard/acceptedConsents/api/acceptedConsentsApi.ts';
import { acceptedConsentsApiQueryKeys } from '@/features/dashboard/acceptedConsents/api/acceptedConsentsApi.queryKeys.ts';
import useWithdrawAcceptedConsent from '@/features/dashboard/acceptedConsents/hooks/useWithdrawAcceptedConsent.ts';
import { AcceptedConsentListDto } from '@/features/dashboard/clients/types/AcceptedConsentListDto.ts';
import { ConsentStatus } from '@/features/dashboard/consentTemplates/types/ConsentStatus.ts';
import { ListSearch } from '@/components/table/routes/listSearchParams.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';

interface AcceptedConsentsTableProps {
  listSearch?: ListSearch;
}

const AcceptedConsentsTable = ({ listSearch }: AcceptedConsentsTableProps) => {
  const { showDialog } = useConfirmationDialogContext();
  const withdrawAcceptedConsent = useWithdrawAcceptedConsent();

  const rowContextMenuItems: RowContextMenuItemParams<AcceptedConsentListDto>[] =
    [
      {
        label: 'Wycofaj zgodę',
        variant: 'destructive',
        disabled: (row) =>
          row.consentStatus !== ConsentStatus.ACCEPTED ||
          row.booking?.status === BookingStatus.CANCELLED,
        action: async (row) => {
          const confirmed = await showDialog({
            title: 'Wycofaj zgodę',
            description:
              'Czy na pewno chcesz wycofać tę zgodę? Tej operacji nie można cofnąć — aby zgoda znów była aktywna, konieczne będzie ponowne wyrażenie jej przez klienta.',
            variant: 'destructive',
            confirmText: 'Wycofaj zgodę',
          });
          if (confirmed) {
            withdrawAcceptedConsent.mutate(row.id);
          }
        },
      },
    ];

  return (
    <Table
      listSearch={listSearch}
      queryKey={acceptedConsentsApiQueryKeys.all()}
      fetchData={acceptedConsentsApi.getAll}
      fetchTableDef={acceptedConsentsApi.getTableDefinition}
      rowContextMenuItems={rowContextMenuItems}
      title="Umowy"
      emptyDataComponent={
        <EmptyTable
          title="Brak umów i zgód"
          description="Tutaj pojawią się wszystkie zgody i umowy zaakceptowane przez klientów."
          icon={<FileCheck />}
        />
      }
    />
  );
};

export default AcceptedConsentsTable;
